import {GetProgressResponse} from 'domain/usecases/private/profile/get-progress';

export const getPendingPercentage = ({
	totalFields = 0,
	filledFields = 0,
}: GetProgressResponse): number => {
	if (!totalFields) return 0;

	if (totalFields <= 0) return 0;

	const safeFilled = Math.max(0, Math.min(filledFields, totalFields));

	const percentage = (safeFilled * 100) / totalFields;

	return Math.max(0, Math.min(100, Math.round(percentage)));
};
